import { MessageApi } from "generated/apiMessages";
import { Configuration } from "generated/configuration";
import { getLoggedinUser } from "helpers/api_helper";

const { REACT_APP_API_URL } = process.env;

export const updateMessage = async (data: any) => {
  const authUser: any = getLoggedinUser();
  const api = new MessageApi(
    new Configuration({
      accessToken: authUser.accessToken || "",
      basePath: `${REACT_APP_API_URL}`,
    })
  );
  return api.messageControllerUpdate({ ...data, managerId: authUser.uid });
};

export const signAsRead = async () => {
  const authUser: any = getLoggedinUser();
  const api = new MessageApi(
    new Configuration({
      accessToken: authUser.accessToken || "",
      basePath: `${REACT_APP_API_URL}`,
    })
  );
  return api.messageControllerSignAsRead(authUser.uid);
};

export const deleteBulkMessage = async (data: any) => {
  const authUser: any = getLoggedinUser();
  const api = new MessageApi(
    new Configuration({
      accessToken: authUser.accessToken || "",
      basePath: `${REACT_APP_API_URL}`,
    })
  );
  return api.messageControllerDelete(data);
};
